'use strict'

export default string => Uint8Array.from(atob(string), c => c.charCodeAt(0))
